<script>
	import { DialogNew, notifications } from '@shopboxai/sb-portal-components';
	import { inviteNewUser } from '../../utils/api.js';
	import { createEventDispatcher } from 'svelte';
	import { validateEmail } from '../../utils/utils.js';
	const dispatch = createEventDispatcher();

	export let visible = false;
	export let data = {};
	let isValidEmail = false;

	const submitInvitation = async () => {
		if (!isValidEmail) return;
		try {
			notifications.info('Inviting new user...', 2000);
			let res = await inviteNewUser(data.email);
			notifications.success(res.detail, 2000);
		} catch (error) {
			notifications.danger('Something went wrong', 2000);
		} finally {
			dispatch('complete');
		}
	};
	const handleClose = async () => {
		data.email = '';
		isValidEmail = false;
	};
</script>

<DialogNew {data} on:submit={submitInvitation} on:close={handleClose} bind:visible>
	<div slot="header">Invite new user</div>
	<button slot="toggle" style="display: none;"> + Invite new user </button>
	<button class="primary" style="display:{isValidEmail ? 'inherit' : 'none'}" slot="primary-action">
		Invite
	</button>
	<div slot="content">
		<label for="email">Email </label>
		<input
			id="email"
			type="email"
			bind:value={data.email}
			required
			on:input={() => {
				isValidEmail = validateEmail(data.email);
			}}
		/>
		{#if !isValidEmail}
			<span class="invalid-email-message"> Enter a valid email </span>
		{/if}
	</div>
</DialogNew>

<style>
	.invalid-email-message {
		font-size: 14px;
		font-weight: 300;
		color: var(--s-c);
	}
</style>
